import React, { useMemo, useEffect } from 'react';
import debounce from 'lodash.debounce';

import { FormattedMessage, useIntl } from '../../util/reactIntl';

import css from './PlacesAutocomplete.module.css';

const PlacesAutocomplete = props => {
  const intl = useIntl();

  const {
    value,
    setValue,
    onPlacesForListing,
    places,
    onSelectPlaceForListing,
    selectedPlace,
    disabled,
  } = props;

  const search = useMemo(
    () =>
      debounce(value => {
        onPlacesForListing({ input: value });
      }, 400),
    [onPlacesForListing]
  );

  useEffect(() => {
    return () => {
      search.cancel();
    };
  }, [search]);

  const onSelect = async place => {
    const { placeId } = place;
    await onSelectPlaceForListing({ placeId });
  };

  return (
    <div className={css.wrapper}>
      <input
        className={css.input}
        placeholder={intl.formatMessage({
          id: 'PlacesAutocomplete.searchPlace',
        })}
        onChange={e => {
          search(e.target.value);
          setValue(e.target.value);
        }}
        value={value}
        disabled={disabled}
      />

      {selectedPlace ? (
        <div className={css.placeNameWrapper}>
          <FormattedMessage id="PlacesAutocomplete.placeName" />
          <a
            className={css.placeLink}
            href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
              selectedPlace?.address || ''
            )}&query_place_id=${selectedPlace?.placeId || ''}`}
            target="_blank"
          >
            {selectedPlace?.name || ''}
          </a>
        </div>
      ) : null}

      {places.length > 0 ? (
        <div className={css.placesWrapper}>
          <ul className={css.places}>
            {places.map(item => (
              <li className={css.place} key={item.placeId} onClick={() => onSelect(item)}>
                {item.text}
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
};

export default PlacesAutocomplete;
